import * as React from 'react';
import API from './API.js';
import Heat from './heat.js';
import Device from './device';

import {initializeWebsocket} from './websocket.js';
import {ConvertGeofencesToGeoJSON} from '../compornents/helpers/convert_geofence_to_geojson'

console.log('initializing')

//URLよりパラメータを取得
export function URLParams() {
  var url = window.location.search;
  var query = url.substr(1);
  var result = {};
  query.split("&").forEach(function(part) {
    var item = part.split("=");
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
}


var tmp
var org_id = URLParams()['org_id']
if( org_id ){
	tmp = org_id;
} else {
	tmp = process.env.REACT_APP_ORGANIZATION_ID;
}
export const organization_id = tmp;

var public_token = URLParams()['public_token']
if( public_token ){
	tmp = public_token;
} else {
	tmp = process.env.REACT_APP_TOKEN;
}

var pmap_token = URLParams()['public_map_token']

export const token = tmp;
export const pm_token = pmap_token;

//デバイス表示設定(Websocket)
var tmp_show_devices = URLParams()['show_devices']
export function show_devices(){
  if(tmp_show_devices==="1"){
    return true
  } else {
    return false
  }
}

export const RACEMANEGEMENT_HOSTNAME = process.env.REACT_APP_RACEMANEGEMENT_HOSTNAME;
export const websocketURL = process.env.REACT_APP_WEBSOCKET_URL + organization_id;

console.log( "Interval time:", process.env.REACT_APP_SEND_INTERVAL )

// token check
if ( token == undefined ){
  alert("Invalid URL. token isn't specified")
}

// organization_id check
if ( organization_id == undefined ){
  alert("Invalid URL. organization_id isn't specified")
}

// host name check
if (!RACEMANEGEMENT_HOSTNAME){
  alert("Invalid RACEMANEGEMENT_HOSTNAME.")
}
console.log(RACEMANEGEMENT_HOSTNAME)
console.log(websocketURL)

export function initialize(setDevices, setOnline, useWs, setGeoJson){
	getDevices(setDevices, setOnline, useWs);

  //public map tokenの指定がある場合のみ
  if(pmap_token){
	  getPublicMap(setGeoJson);
  }
}

function getDevices(setDevices, setOnline, useWs){
	let success =  function(ret) {
    let data = ret.data;
    let deviceMap = new Map();
    data.map(function(d, i) {
      deviceMap.set( d.serial, new Device(d.serial, d));
    });
    setDevices(deviceMap);

    //initialize websocket
		if(useWs)
			initializeWebsocket( deviceMap, setDevices, setOnline );
	}
	let error = function(data){
		alert('デバイスデータ取得に失敗しました');
	}
	API.getDevices({ token: token, host: RACEMANEGEMENT_HOSTNAME, organization_id: organization_id, onSuccess: success, onError: error })
}

// PublicMapのジオフェンスを取得する
function getPublicMap(setGeoJson){
	let success2 =  function(ret) {
    setGeoJson(
      ConvertGeofencesToGeoJSON(ret.data)
    );
	}
	let error2 = function(data){
		alert('ジオフェンスデータ取得に失敗しました');
	}

	API.getPublicMap({ token: token, host: RACEMANEGEMENT_HOSTNAME, pmap_token: pmap_token, organization_id: organization_id, onSuccess: success2, onError: error2 })
}

export function wsURL(){
 return websocketURL;
}
